import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defaultSelectMultipleAnswer, answerInSelectMultipleFormat } from '../../../selectors/questions.js';
import { TranslationContext } from "@c/Translations";

class MultipleChoiceQuestion extends Component {
    constructor(props) {
        super(props);

        // show the write-in input if the answer exists but isn't an option
        let showWriteInInput = false;
        if (!this.props.selectMultiple && this.props.answer !== '' && this.props.options.indexOf(this.props.answer) === -1) {
            showWriteInInput = true;
        }
        if (this.props.selectMultiple && !!this.props.answer?.writeIn) {
            showWriteInInput = true;
        }
        this.state = {
            showWriteInInput,
            configurationOptionClass: "input input__control input__select--unselected"
        };
    }

    getComponentId = () => {
        return `multiple_choice_option_q${this.props.id}_e${this.props.elementId}`;
    }

    getOptions() {
        if (this.props.options) {
            return this.props.options.map((option, i) => {
                if (this.props.selectMultiple) {
                    return (
                        <div className="input__question__multiple-choice" key={i}>
                            <input
                                id={`${this.getComponentId()}_${i}`}
                                type="checkbox"
                                checked={this.getAnswer().selectedOptions.includes(option)}
                                onChange={() => {this.toggleSelectedOption(option)}}
                            />
                            <label htmlFor={`${this.getComponentId()}_${i}`}>{` ${option}`}</label>
                        </div>
                    );
                }
                return (
                    <option value={option} key={i}>
                        {option}
                    </option>
                );
            });
        }
        return '';
    }

    getWriteInInput = (value, onChange, className = '') => {
        return (
            <TranslationContext.Consumer>
            {t =>
                <input
                    type="text"
                    className={className}
                    placeholder={t.t('checkout__enter_response_here')}
                    value={value}
                    onChange={onChange}
                    onFocus={this.onFocus}
                />
            }
          </TranslationContext.Consumer>
        );
    }

    getAnswer = () => {
        if (this.props.selectMultiple) {
            return answerInSelectMultipleFormat(this.props.answer) ? {...this.props.answer} : defaultSelectMultipleAnswer();
        }
        return this.props.answer;
    }

    toggleSelectedOption = option => {
        if (this.props.selectMultiple) {
            const answer = this.getAnswer();
            if (!answer.selectedOptions.includes(option)) {
                answer.selectedOptions.push(option);
            } else {
                answer.selectedOptions = answer.selectedOptions.filter(opt => opt != option);
            }
            this.props.onAnswerUpdate(answer);
        }
    }

    setWriteInForSelectMultiple = val => {
        if (this.props.selectMultiple) {
            const answer = this.getAnswer();
            answer.writeIn = val;
            this.props.onAnswerUpdate(answer);
        }
    }

    render() {

        if (this.props.selectMultiple) {
            return (
                <div>
                    {this.getOptions()}
                    {!!this.props.writeIn && (
                        <div className="input__question__multiple-choice input__question__multiple-choice--write-in">
                            <input
                                id={`${this.getComponentId()}_write_in`}
                                type="checkbox"
                                checked={!!this.state.showWriteInInput}
                                onChange={() => {
                                    if (this.state.showWriteInInput) {
                                        this.clearWriteInInput();
                                    } else {
                                        this.setState({showWriteInInput: true})
                                    }
                                }}
                            />
                            <label htmlFor={`${this.getComponentId()}_write_in`}>{` ${this.props.writeInOption}`}</label>
                        </div>
                    )}
                    {!!this.state.showWriteInInput && (
                        <div className="input">
                            {this.getWriteInInput(this.getAnswer()?.writeIn ?? '', e => {
                                this.setWriteInForSelectMultiple(e.target.value);
                            }, 'input input__control')}
                        </div>
                    )}
                </div>
            );
        }

        return(
            <TranslationContext.Consumer>
            {t =>
                <div>
                    {this.state.showWriteInInput === false && <div className="input__select">
                        <select className={this.state.configurationOptionClass} onChange={this.onAnswerUpdate} value={this.getAnswer()}>
                            <option value="">
                                {t.t('checkout__please_choose_an_answer')}
                            </option>
                            {this.getOptions()}
                            {this.getWriteInOption()}
                        </select>
                    </div>}

                    {this.state.showWriteInInput === true && <div className="question__write-in">
                        <div className="input input__control__group">
                            {this.getWriteInInput(this.getAnswer(), this.onAnswerUpdate, this.state.configurationOptionClass)}
                            <div className="input input__control__group__addon">
                                <button onClick={this.clearWriteInInput} className="button--clear question__remove-write-in">
                                    <i className="icon-close" aria-hidden="true"></i>
                                    <span className="sr-only">{t.t('checkout__clear_response')}</span>
                                </button>
                            </div>
                        </div>
                    </div>}
                </div>
            }
            </TranslationContext.Consumer>
        )
    }

    onFocus = (e) => {
        if(this.props.onFocus) {
            this.props.onFocus(e, this.props.question);
        }
    }

    clearWriteInInput = () => {
        if (this.props.selectMultiple) {
            this.setWriteInForSelectMultiple('');
        } else {
            this.props.onAnswerUpdate('');
        }
        this.setState({
            showWriteInInput: false,
            configurationOptionClass: "input input__control input__select--unselected"
        });
    }

    getWriteInOption = () => {
        if(this.props.writeIn === true) {
            return <option value="writeIn">
                {this.props.writeInOption}
            </option>
        }

        return null;
    }

    getWrapperClass = () => {
        let className = "input";

        if(this.props.writeIn === true) {
            className += " question--write-in-open";
        }

        return className;
    }

    onAnswerUpdate = (e) => {
        if(e.target.value === "writeIn") {
            this.props.onAnswerUpdate('');
            this.setState({showWriteInInput: true});
            return;
        }
        this.props.onAnswerUpdate(e.target.value);

        //update class for placeholder
        if (this.props.answer.value !== null && this.props.answer.value !== "") {
            this.setState({configurationOptionClass: "input input__control"});
        } else {
            this.setState({configurationOptionClass: "input input__control input__select--unselected"});
        }
    }
}

MultipleChoiceQuestion.defaultProps = {
    selectedOption: ""
}

MultipleChoiceQuestion.propTypes = {
    options: PropTypes.array.isRequired,
    selectedOption: PropTypes.string,
    onAnswerUpdate: PropTypes.func.isRequired,
    writeIn: PropTypes.bool,
    writeInOption: PropTypes.string,
    selectMultiple: PropTypes.bool,
}

export default MultipleChoiceQuestion;
